import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { usePhotoSeriesAdd } from "hooks/citajteo/photo_series/usePhotoSeriesAdd";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import PhotoSeriesForm, {
  PHOTO_SERIES_EMPTY_FORM,
  PhotoSeriesFormState,
} from "components/admin/common/photo_series/PhotoSeriesForm/PhotoSeriesForm";
import { PhotoSeriesType } from "constant/photo_series/photo_series_type.constant";

const PhotoSeriesNew: React.FC = () => {
  const navigate = useNavigate();
  const { photoSeriesAddMutate } = usePhotoSeriesAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_PHOTO_SERIES_SEARCH],
  });

  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<PhotoSeriesFormState>({
    defaultValues: PHOTO_SERIES_EMPTY_FORM,
  });

  const [errorText, setErrorText] = useState("");

  const handleSubmit = (form: PhotoSeriesFormState) => {
    setErrorText("");

    const trimmedName = form.name.trim();
    const trimmedSlug = form.slug.trim();
    const trimmedGroup = form.group.trim();
    const sType = form.sType as PhotoSeriesType;
    const trimmedDesc = form.desc.trim();

    if (trimmedName === "") {
      setErrorText("Naziv ne sme biti prazan.");
      return;
    }

    if (trimmedGroup === "") {
      setErrorText("Grupa ne sme biti prazna.");
      return;
    }

    const updatePayload = {
      name: trimmedName,
      slug: trimmedSlug,
      desc: trimmedDesc,
      group: trimmedGroup,
      sType,
    };

    photoSeriesAddMutate(updatePayload, {
      onSuccess: () => {
        toast.success("Uspešno dodavanje foto serije.");
        navigate("/admin-dashboard/photo-ser-li");
      },
      onError: (error) => {
        console.error("Error adding photo series:", error);
        toast.error("Greška prilikom dodavanja foto serije.");
      },
    });
  };

  const handleReset = () => {
    reset(PHOTO_SERIES_EMPTY_FORM);
    setErrorText("");
  };

  return (
    <FullWidth>
      <div className="App">
        <PhotoSeriesForm
          control={control}
          errorText={errorText}
          isEditMode={false}
          onSubmit={handleFormSubmit(handleSubmit)}
          onReset={handleReset}
        />
      </div>
    </FullWidth>
  );
};

export default PhotoSeriesNew;

const FullWidth = styled.div`
  width: 100%;
`;
